import { type IHydratedWidget } from '../../../../../hydrate/IHydrationContext.ts';
import { type IHtmlRenderContext } from '../../../IWidgetType.ts';
import { type IPageBreakWidget } from './IPageBreakWidget.ts';

export function renderPageBreakHtml(
  widget: IHydratedWidget<IPageBreakWidget>,
  context: IHtmlRenderContext,
): string {
  return '<div style="page-break-before:always"></div>';
}
